import React from "react"
import SlateNode from "../slate-node"
import getStyles from "./get-styles"

const Button = ({ attributes, data, children, node }) => {
  let { href } = data

  const normalizeUrl = url =>
    !/^https?:\/\//i.test(url) ? `https://${url}` : url

  const style = getStyles(data)

  const {
    textAlign,
    backgroundColor,
    color,
    display,
    fontSize,
    margin,
    width,
    borderColor,
    borderRadius,
    borderWidth,
    padding
  } = style

  return (
    <SlateNode
      node={node}
      {...attributes}
      style={{
        width: "100%",
        display: "flow-root",
        textAlign,
        margin: margin
      }}
    >
      <a
        href={normalizeUrl(href)}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display,
          textDecoration: "none",
          borderStyle: "solid",
          textAlign,
          backgroundColor,
          color,
          fontSize,
          width,
          borderColor,
          borderRadius,
          borderWidth,
          padding
        }}
      >
        {children}
      </a>
    </SlateNode>
  )
}

export default Button
